import cn from 'classnames';

import { AppPreview } from 'components/AppPreview';
import { HOST_CLIENT_APP } from 'config';
import { Typography } from 'components/Typography/Typography';
import { useCollapseDrawer } from 'hooks/useCollapseDrawer';
import { Logo } from 'components/Logo';
import { CollapseButton } from './CollapseButton';
import { NavMenu } from 'components/NavMenu/NavMenu';
import { NavbarAccount } from './NavbarAccount';
import { CommentsComplaintsIndicator } from 'components/CommentsComplaintsIndicator/CommentsComplaintsIndicator';

import s from './NavbarVertical.module.scss';

export const NavbarVertical = () => {
  const { opened, hovered, setHovered } = useCollapseDrawer();

  const handleMouseEnter = () => {
    if (!opened && !hovered) setHovered(true);
  };

  const handleMouseLeave = () => {
    if (!opened && hovered) setHovered(false);
  };

  return (
    <nav
      className={cn(s.navbar, { [s.closed]: !opened, [s.hovered]: !opened && hovered })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <header className={s.header}>
        <CollapseButton />
        <Logo />
        {(opened || hovered) && (
          <div className={s.indicator}>
            <CommentsComplaintsIndicator />
          </div>
        )}
      </header>

      <NavbarAccount />

      <NavMenu />

      <footer className={s.footer}>
        <AppPreview label="Приложение" src={HOST_CLIENT_APP} fullWidth size="small" />
        {process.env.REACT_APP_VERSION && (
          <Typography fontSize="1rem" lineHeight="24px" display="block" marginTop="8px">
            Версия {process.env.REACT_APP_VERSION}
          </Typography>
        )}
      </footer>
    </nav>
  );
};
